import { Row, Col } from "react-bootstrap";
import { Base } from "../../components/RootLayout";
import TopNavigation from "../../components/TopNavigation";
import * as Assets from "../../utils/svg_assets";
import Comment from "./comment";
import PostComment from "./postComment";
import ApiUtils from "../../utils/api_utils";

const DetailLikeComment = (props) => {
  const { data, title, onClick } = props;

  return (
    <Base>
      <TopNavigation
        titlePage={`${title} (${data.length})`}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
        onClick={onClick}
      />
      <div className="page-reply-comment container mt-2">
        {title === "Like" ? (
          data &&
          data.map((dt) => {
            return (
              <Row key={dt.id} className="mb-3">
                <Col xs={2} sm={2} md={2}>
                  <div className="circular-image mr-1">
                    <img
                      src={ApiUtils.validateImgUrl({ url: dt.creator.image })}
                      alt=""
                    />
                  </div>
                </Col>
                <Col>
                  <div>
                    <div className="fs-16 mb-2">
                      <div>{dt.creator.name}</div>
                    </div>
                  </div>
                </Col>
              </Row>
            );
          })
        ) : (
          <div className="wrapper-comment">
            <Comment data={data} />
            <div className="position-fixed bottom-0 post-comment-form">
              <PostComment />
            </div>
          </div>
        )}
      </div>
    </Base>
  );
};

export default DetailLikeComment;
